import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';



import { ModulosController } from '../../modulos-controller';

import { RelatoriosContabeisService } from '../../../../providers/relatorios-contabeis-service';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';
/*
  Generated class for the RelatoriosContabeis page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-relatorios-contabeis',
  templateUrl: 'relatorios-contabeis.html',
  providers: [
    RelatoriosContabeisService
  ]
})
export class RelatoriosContabeisPage extends ModulosController {
  // Lista Construtora da Página
  listaRelatorios: any = [ ];
  idSecaoPagina: string = "1001";

  //Construtor da Página
  constructor(private relatoriosContabeisService: RelatoriosContabeisService, public alertService: AlertService, public usuarioService: UsuarioService, public modalCtrl: ModalController, public navParams: NavParams, public gestaoPcaService: GestaoPcaService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
    this.carregarModulo();
    this.setModuloId(24);
  }

  carregarModulo() {
    this.listarRelatorios();
  }

  listarRelatorios() {
    this.relatoriosContabeisService.obterListaRelatorios().subscribe(data => {
      this.listaRelatorios = data;
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Houve um erro ao listar relatórios.");
    });
  }

  /* ======================================================================
  *
  *  Ações referentes ao relatório
  *
  ========================================================================= */
  visualizarArquivos(relatorio) {
    this.visualizarTelaEvidencias("Vinculação de Arquivo", relatorio, this.relatoriosContabeisService, "application/pdf,application/xml");
  }

  submeterRelatorio(relatorio) {
    this.relatoriosContabeisService.submeterRelatorio(relatorio).subscribe(data => {
      this.alertService.mostraAlerta("", "Relatório submetido com sucesso.");
      this.carregarModulo();
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Houve um erro ao submeter relatório.");
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/modulos/relatorios-contabeis/pecas-processuais/relatorios-contabeis.ts